import React from 'react';
import { Form, Input, Textarea, Checkbox } from 'formsy-react-components';
import { i18n } from 'common';

import {
  Box, BoxContent, Grid, Column, Tag, Icon, Footer,
  AdminForm, AdminInput, AdminTextArea,
  AdminIconPicker, AdminButton
} from '../components';


const ICON_LIST = ['car', 'bed', 'coffee', 'diamond', 'battery', 'code', 'gamepad', 'motorcycle', 'dashboard', 'taxi', 'video-camera', 'wifi', 'bath', 'truck', 'rocket', 'key', 'phone', 'support',
                  'glass', 'music', 'search', 'envelope', 'heart', 'star', 'star-o', 'user', 'film', 'th-large', 'th', 'th-list', 'check-circle', 'remove', 'power-off', 'signal', 'cog', 'trash', 'home', 'file', 'clock-o', 'road', 'cloud-download', 'download', 'upload', 'inbox', 'play-circle', 'repeat', 'refresh', 'list-alt', 'lock',
                  'flag', 'headphones', 'volume-off', 'volume-down', 'volume-up', 'qrcode', 'barcode', 'tag', 'tags', 'book', 'bookmark', 'print', 'camera', 'font', 'bold', 'italic', 'text-height', 'text-width', 'align-left', 'align-center', 'align-right', 'align-justify', 'list', 'indent', 'youtube', 'picture-o',
                  'pencil', 'map-marker', 'adjust', 'tint', 'edit', 'share', 'check', 'move', 'step-backward', 'fast-backward', 'backward', 'play', 'pause', 'stop', 'forward', 'fast-forward', 'step-forward', 'eject', 'chevron-left', 'chevron-right', 'plus', 'minus', 'remove', 'check', 'question', 'info', 'desktop',
                  'minus-circle', 'check-circle-o', 'ban', 'arrow-left', 'arrow-right', 'arrow-up', 'arrow-down', 'share-alt', 'expand', 'arrows', 'plus', 'minus', 'asterisk', 'exclamation', 'gift', 'leaf', 'fire', 'eye', 'eye-slash', 'exclamation-triangle', 'plane', 'calendar', 'random', 'comment', 'magnet', 'chevron-up',
                  'chevron-down', 'retweet', 'shopping-cart', 'folder', 'folder-open', 'arrows-h', 'arrows-v', 'hdd-o', 'bullhorn', 'bell', 'certificate', 'thumbs-up', 'thumbs-down', 'hand-o-right', 'hand-o-left', 'hand-o-up', 'hand-o-down', 'arrow-circle-o-right', 'arrow-circle-o-left', 'arrow-circle-o-up', 'arrow-circle-o-down', 'globe',
                  'wrench', 'tasks', 'filter', 'briefcase', 'television'];


export default
class ScopeEdit extends AdminForm {
  config = {
    url: 'api/scopes/',
    backUrl: '/scopes'
  }

  render() {
    const { initialObject } = this.state;

    return (
      <Box>
        <BoxContent>
          <Form ref="form" onValidSubmit={this.onSubmit} onInvalidSubmit={this.onInvalid}>
            <Grid columns="2">
              <Column>
                <AdminInput name="value" value={initialObject.value} label={i18n('scope-form.fields.value')}
                            placeholder={i18n('scope-form.placeholders.value')}
                            validations="isExistyScope" validationError={i18n('error.non-latin-required')} />

                <AdminTextArea name="description" value={initialObject.description}
                               label={i18n('scope-form.fields.description')} placeholder={i18n('scope-form.placeholders.description')}
                               validations="isExisty" validationError={i18n('error.required')} />

                <div className="f-group flex-group">
                  <div className="mr2">
                    <Tag color="green"><Icon src="flag" /></Tag>
                  </div>

                  <div>
                    <Checkbox name="defaultScope" value={initialObject.defaultScope} valueLabel={i18n('scope-form.fields.default-scope')} layout="elementOnly" />
                    <p>{i18n('scope-form.hints.default-scope')}</p>
                  </div>
                </div>

                <div className="f-group flex-group">
                  <div className="mr2">
                    <Tag color="orange"><Icon src="ban" /></Tag>
                  </div>

                  <div>
                    <Checkbox name="restricted" value={initialObject.restricted} valueLabel={i18n('scope-form.fields.restricted')} layout="elementOnly" />
                    <p>{i18n('scope-form.hints.restricted')}</p>
                  </div>
                </div>

              </Column>

              <Column>
                <h2>{i18n('scope-form.fields.icon')}</h2>

                <div>
                  <AdminIconPicker name="icon"
                                   value={initialObject.icon} items={ICON_LIST} />
                </div>
              </Column>
            </Grid>

            <Footer className="txtcenter mt2">
              <div className="mt3">
                <AdminButton type="submit" className="mr2" />
                <AdminButton type="cancel" onClick={this.onCancel} />
              </div>
            </Footer>
          </Form>
        </BoxContent>
      </Box>
    );
  }
};
